var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row flex-grow" }, [
    _c("div", { staticClass: " col-xl-4 col-lg-6 mx-auto" }, [
      _c(
        "form",
        {
          staticClass: "auth-form-light text-left pl-5 pr-5 pb-5",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.createAccount($event)
            }
          }
        },
        [
          _c("div", { staticClass: "brand-logo text-right" }, [
            _c("img", {
              attrs: {
                src: "/media/aform-logo-black.png",
                alt: "Coachingclub.lu"
              }
            })
          ]),
          _vm._v(" "),
          _c("h4", [_vm._v(_vm._s(_vm.$t("pages.register.title")))]),
          _vm._v(" "),
          _c("h6", { staticClass: "font-weight-light" }, [
            _vm._v(_vm._s(_vm.$t("pages.register.subtitle")))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pt-3" }, [
            _c(
              "div",
              { staticClass: "form-group mt-4" },
              [
                _c("label", { attrs: { for: "preferred_language" } }, [
                  _vm._v(_vm._s(_vm.$t("pages.register.preferred_language")))
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.preferred_language,
                        expression: "preferred_language"
                      }
                    ],
                    staticClass: "form-control",
                    class: {
                      "is-invalid": _vm.$errors.has("preferred_language")
                    },
                    attrs: {
                      id: "preferred_language",
                      placeholder: _vm.$t("user.preferred_language")
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.preferred_language = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  [
                    _c("option", { attrs: { value: "lb" } }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("languages.luxembourgish")) +
                          "\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "en" } }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("languages.english")) +
                          "\n                        "
                      )
                    ]),
                    _vm._v(" "),
                    _c("option", { attrs: { value: "de" } }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.$t("languages.german")) +
                          "\n                        "
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("error", { attrs: { input: "preferred_language" } })
              ],
              1
            ),
            _vm._v(" "),
            _c("hr", { staticClass: "mt-4 mb-4" }),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "first_name" } }, [
                      _vm._v(_vm._s(_vm.$t("pages.register.first_name")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.first_name,
                          expression: "first_name"
                        }
                      ],
                      staticClass: "form-control form-control-lg",
                      class: { "is-invalid": _vm.$errors.has("first_name") },
                      attrs: {
                        id: "first_name",
                        type: "text",
                        placeholder: _vm.$t("pages.register.first_name")
                      },
                      domProps: { value: _vm.first_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.first_name = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("error", { attrs: { input: "first_name" } })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "first_name" } }, [
                      _vm._v(_vm._s(_vm.$t("pages.register.last_name")))
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.last_name,
                          expression: "last_name"
                        }
                      ],
                      staticClass: "form-control form-control-lg",
                      class: { "is-invalid": _vm.$errors.has("last_name") },
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("pages.register.last_name")
                      },
                      domProps: { value: _vm.last_name },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.last_name = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("error", { attrs: { input: "last_name" } })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row", attrs: { id: "date_of_birth" } }, [
              _c("div", { staticClass: "col-12" }, [
                _c("div", { staticClass: "form-group mb-0" }, [
                  _c("label", { attrs: { for: "date_of_birth" } }, [
                    _vm._v(_vm._s(_vm.$t("pages.register.date_of_birth")))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.day,
                            expression: "day"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: {
                          "is-invalid": _vm.$errors.has("date_of_birth.day")
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.day = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [_vm._v(_vm._s(_vm.$t("pages.register.day")))]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.daysList, function(dayInList) {
                          return _c(
                            "option",
                            { domProps: { value: dayInList } },
                            [_vm._v(_vm._s(dayInList))]
                          )
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("error", { attrs: { input: "date_of_birth.day" } })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.month,
                            expression: "month"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: {
                          "is-invalid": _vm.$errors.has("date_of_birth.month")
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.month = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [_vm._v(_vm._s(_vm.$t("pages.register.month")))]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.monthList, function(monthInList, i) {
                          return _c("option", { domProps: { value: i } }, [
                            _vm._v(_vm._s(monthInList))
                          ])
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("error", { attrs: { input: "date_of_birth.month" } })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4" }, [
                _c(
                  "div",
                  { staticClass: "input-group" },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.year,
                            expression: "year"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: {
                          "is-invalid": _vm.$errors.has("date_of_birth.year")
                        },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.year = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [_vm._v(_vm._s(_vm.$t("pages.register.year")))]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.yearList, function(yearInList) {
                          return _c(
                            "option",
                            { domProps: { value: yearInList } },
                            [_vm._v(_vm._s(yearInList))]
                          )
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("error", { attrs: { input: "date_of_birth.year" } })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group mt-4" },
              [
                _c("label", { attrs: { for: "email" } }, [
                  _vm._v(_vm._s(_vm.$t("pages.register.email")))
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "form-control form-control-lg",
                  class: { "is-invalid": _vm.$errors.has("email") },
                  attrs: {
                    id: "email",
                    type: "email",
                    placeholder: _vm.$t("pages.register.email")
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("error", { attrs: { input: "email" } })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-4" }, [
              _c("label", { attrs: { for: "phone_number" } }, [
                _vm._v(_vm._s(_vm.$t("pages.register.phone_number")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-md-4" },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.phone_prefix_id,
                            expression: "phone_prefix_id"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: {
                          "is-invalid": _vm.$errors.has("phone_prefix")
                        },
                        attrs: { id: "phone_prefix_id" },
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.phone_prefix_id = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "", disabled: "", selected: "" } },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("pages.register.phone_prefix"))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.sortedCallingCodes, function(phone_prefix) {
                          return _c(
                            "option",
                            { domProps: { value: phone_prefix.id } },
                            [
                              _vm._v(
                                "+" +
                                  _vm._s(phone_prefix.calling_code) +
                                  " (" +
                                  _vm._s(phone_prefix.name) +
                                  ")"
                              )
                            ]
                          )
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("error", { attrs: { input: "phone_prefix_id" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-8" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.phone_number,
                          expression: "phone_number"
                        }
                      ],
                      staticClass: "form-control form-control-lg",
                      class: { "is-invalid": _vm.$errors.has("phone_number") },
                      attrs: {
                        id: "phone_number",
                        type: "tel",
                        placeholder: _vm.$t("pages.register.phone_number")
                      },
                      domProps: { value: _vm.phone_number },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.phone_number = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("error", { attrs: { input: "phone_number" } })
                  ],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "mt-4 mb-4" }),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "password" } }, [
                _vm._v(_vm._s(_vm.$t("pages.register.password")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _vm.getPasswordInputType === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.$errors.has("password") },
                        attrs: {
                          id: "password",
                          placeholder: _vm.$t("pages.register.password"),
                          type: "checkbox"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.password)
                            ? _vm._i(_vm.password, null) > -1
                            : _vm.password
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.password,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.password = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.password = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.password = $$c
                            }
                          }
                        }
                      })
                    : _vm.getPasswordInputType === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.$errors.has("password") },
                        attrs: {
                          id: "password",
                          placeholder: _vm.$t("pages.register.password"),
                          type: "radio"
                        },
                        domProps: { checked: _vm._q(_vm.password, null) },
                        on: {
                          change: function($event) {
                            _vm.password = null
                          }
                        }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password,
                            expression: "password"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.$errors.has("password") },
                        attrs: {
                          id: "password",
                          placeholder: _vm.$t("pages.register.password"),
                          type: _vm.getPasswordInputType
                        },
                        domProps: { value: _vm.password },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password = $event.target.value
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-dark text-white",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            _vm.showPassword = !_vm.showPassword
                          }
                        }
                      },
                      [_c("i", { staticClass: "mdi mdi-eye" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("error", { attrs: { input: "password" } })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group mt-4" }, [
              _c("label", { attrs: { for: "password_confirmation" } }, [
                _vm._v(_vm._s(_vm.$t("pages.register.password_confirmation")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group" },
                [
                  _vm.getPasswordInputType === "checkbox"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password_confirmation,
                            expression: "password_confirmation"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.$errors.has("password") },
                        attrs: {
                          id: "password_confirmation",
                          placeholder: _vm.$t(
                            "pages.register.password_confirmation"
                          ),
                          type: "checkbox"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.password_confirmation)
                            ? _vm._i(_vm.password_confirmation, null) > -1
                            : _vm.password_confirmation
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.password_confirmation,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.password_confirmation = $$a.concat([
                                    $$v
                                  ]))
                              } else {
                                $$i > -1 &&
                                  (_vm.password_confirmation = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.password_confirmation = $$c
                            }
                          }
                        }
                      })
                    : _vm.getPasswordInputType === "radio"
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password_confirmation,
                            expression: "password_confirmation"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.$errors.has("password") },
                        attrs: {
                          id: "password_confirmation",
                          placeholder: _vm.$t(
                            "pages.register.password_confirmation"
                          ),
                          type: "radio"
                        },
                        domProps: {
                          checked: _vm._q(_vm.password_confirmation, null)
                        },
                        on: {
                          change: function($event) {
                            _vm.password_confirmation = null
                          }
                        }
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.password_confirmation,
                            expression: "password_confirmation"
                          }
                        ],
                        staticClass: "form-control form-control-lg",
                        class: { "is-invalid": _vm.$errors.has("password") },
                        attrs: {
                          id: "password_confirmation",
                          placeholder: _vm.$t(
                            "pages.register.password_confirmation"
                          ),
                          type: _vm.getPasswordInputType
                        },
                        domProps: { value: _vm.password_confirmation },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.password_confirmation = $event.target.value
                          }
                        }
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-dark text-white",
                        attrs: { type: "button" },
                        on: {
                          cli3ck: function($event) {
                            _vm.showPassword = !_vm.showPassword
                          }
                        }
                      },
                      [_c("i", { staticClass: "mdi mdi-eye" })]
                    )
                  ]),
                  _vm._v(" "),
                  _c("error", { attrs: { input: "password" } })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group" }, [
              _c(
                "div",
                { staticClass: "form-check form-check-primary mt-4" },
                [
                  _c("label", { staticClass: "form-check-label" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.privacy_consent,
                          expression: "privacy_consent"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.privacy_consent)
                          ? _vm._i(_vm.privacy_consent, null) > -1
                          : _vm.privacy_consent
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.privacy_consent,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.privacy_consent = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.privacy_consent = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.privacy_consent = $$c
                          }
                        }
                      }
                    }),
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("pages.register.privacy_consent")) +
                        "\n                            "
                    ),
                    _c("i", { staticClass: "input-helper" })
                  ]),
                  _vm._v(" "),
                  _c("error-no-form-field", {
                    attrs: { input: "privacy_consent" }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-4 text-center" }, [
              _c("p", {
                staticClass: "text-small",
                domProps: {
                  innerHTML: _vm._s(_vm.$t("pages.register.terms_agreement"))
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-block btn-outline-dark btn-lg font-weight-medium auth-form-btn"
                },
                [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$t("pages.register.create_account")) +
                      "\n                    "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "my-2 d-flex justify-content-between align-items-center text-center"
              },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "text-dark",
                    attrs: { to: { name: "login" } }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("pages.register.already_have_account")) +
                        "\n                    "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }